/* IU4.3.2 — local vertical tabs. Existing menu open/close, focus trap and links remain native. */
(() => {
  function init() {
    document.querySelectorAll('[data-iu-mobile-rail]').forEach(root => {
      if (root.dataset.iuRailReady === 'true') return;
      const list = root.querySelector('[role="tablist"]');
      if (!list) return;
      const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
      const panels = tabs.map(tab => root.querySelector('#' + tab.getAttribute('aria-controls')));
      if (!tabs.length || panels.some(panel => !panel)) return;
      const select = (index, focus = false) => {
        tabs.forEach((tab, position) => {
          const active = position === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          panels[position].hidden = !active;
        });
        if (focus) tabs[index].focus({ preventScroll: true });
      };
      tabs.forEach((tab, index) => tab.addEventListener('click', () => select(index)));
      list.addEventListener('keydown', event => {
        const current = tabs.indexOf(event.target.closest('[role="tab"]'));
        if (current < 0) return;
        let next;
        if (event.key === 'ArrowDown') next = (current + 1) % tabs.length;
        else if (event.key === 'ArrowUp') next = (current - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        select(next, true);
      });
      root.dataset.iuRailReady = 'true';
      const selected = tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true');
      select(selected < 0 ? 0 : selected);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
